import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import * as commonActions from './../../actions/commonActions';
import styles from './AddWidget.less';
import * as dashboardActions from './../../actions/dashboardActions';
import * as activityActions from './../../actions/activityActions';
import i18next from 'i18next';
import { applyStyle, applyClickActive,applyToHover,setDirection } from './../../utils/utils';
import appConstants from './../../appConstants';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
@connect(
  state => ({
    modal: state.dashboardRoot.commonReducer.modal,
    layout: state.dashboardRoot.dashboardReducer.layout,
    dashboardWidgets: state.dashboardRoot.dashboardReducer.dashboardWidgets,
    deleteWidgetKey: state.dashboardRoot.dashboardReducer.deleteWidgetKey,
    userDetail: state.auth.userDetail,
   // selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
    tradeWidgetCnt:state.dashboardRoot.dashboardReducer.tradeWidgetCnt,
    selectedLang:state.dashboardRoot.commonReducer.selectedLang,
    DFA:state.auth.DFA,
  }),
    {...dashboardActions, ...commonActions, ...activityActions})

export default class AddWidget extends Component {
  constructor(props){
    super(props);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }
  static propTypes = {
    modal: PropTypes.string,
    //CloseIcon: PropTypes.String,
    addWidget: PropTypes.func,
    layout: PropTypes.array,
    isInstrument: PropTypes.bool,
    isMargin: PropTypes.bool,
    handleModal: PropTypes.func,
    userDetail:PropTypes.object,
    tradeCnt:PropTypes.func,
    setRefreshFlag:PropTypes.func,
    orderRefreshFlag:PropTypes.func
  }
state={
  scrollbottom:false,
  visible:false,
  isAddWidgetDisabled:false,
  checkClickOnAddWidgetFlag:false
}
  closeModal = () => {
    try{
      this.props.handleModal(false);
      this.setState({scrollbottom:false});
      this.props.setTooltipFlag(true);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeModal', component:"AddWidget"});
    }
  }

  addNewWidget = (widget) => {
    try{
      if(widget == 'trade')
      {
        var count=this.props.tradeWidgetCnt;
        count++;
        this.props.tradeCnt(count);
      }
      let layoutAdd;
      if (this.props.layout) {
        layoutAdd = this.props.layout;
      } else {
        layoutAdd = [];
      }
      if(widget === 'TradeActivityBook'){
      this.props.setRefreshFlag(false);
      this.props.orderRefreshFlag(false);
    }
      this.setState({isAddWidgetDisabled: true});
      this.props.addWidget(widget, layoutAdd);
      this.setState({scrollbottom:true});
      setTimeout(function() {
        this.setState({isAddWidgetDisabled: false})
      }.bind(this), 2000);
      this.closepopModal();
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'addNewWidget', component:"AddWidget"});
    }
  }
  closepopModal = () => {
    try{
      this.props.setTooltipFlag(true);
      this.props.handleModal(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closepopModal', component:"AddWidget"});
    }
  }
  componentWillReceiveProps(nextProps, nextState){
     //console.log(this.state.checkClickOnAddWidgetFlag);
     //this.props.checkClickOnAddWidget(true);
  }
  componentDidUpdate(){
    if(this.state.scrollbottom === true){
      var docHeight=document.body.offsetHeight;
      var startingY = 0;
      var duration=3000;
      var targetY = docHeight;
	    var diff = targetY - startingY
      var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
      var start
      if (!diff) return
	     window.requestAnimationFrame(function step(timestamp) {
         if (!start) start = timestamp
         var time = timestamp - start
         var percent = Math.min(time / duration, 1)
         percent = easing(percent)
         window.scrollTo(0, startingY + diff * percent)
         if (time < duration) {
           window.requestAnimationFrame(step)
         }
       })
      this.setState({scrollbottom:false});
    }
  }
  afterOpenModal() {
    try{
      const thisComponent = this.refs.addWidget;
      // //const allCssStyleRules = this.props.selectedCssColorTheme;
      // const elementsData = [
      //   {"classNames":"addWidgetHeader", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"addWidgetTitle", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"closeBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"addWidgetBody", "elementType":"normal", "applyTo":"single", "tagNames":"div"}
      // ];
      const directionData = [
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"addWidgetBodyDiv", "elementType":"normal", "applyTo":"single", "tagNames":"div"}
      ];
      //applyStyle(thisComponent, allCssStyleRules, elementsData);
      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
          {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"}
      ];
      //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"AddWidget"});
    }
  }
  render() {
    const tco=JSON.parse(localStorage.getItem('TCO'));
    return (
      <div id="addWidgetMainDiv">
        <Modal
          isOpen={this.props.modal}
          className="contentAddWidget"
          overlayClassName="overlay"
          closeTimeoutMS={350}
          contentLabel="Example Modal" id="widgetModal" onAfterOpen={this.afterOpenModal}>
           <div ref="addWidget" className="mdlWrap">
          <div className={`${styles.addWidgetHeader} addWidgetHeader`}>
            <span className={`${styles.addWidgetTitle} addWidgetTitle`}>{i18next.t("selectWidget")}</span>
            <span onClick={this.closeModal} id="closeWidgetModal" className={`${styles.closeImg} closeIcon commonCloseIcon`}><MUIIconWithTooltip icon={"Close"} className={"closeBtn"} title={i18next.t("close")}/></span>
          </div>
          <div className={`${styles.addWidgetBody} addWidgetBodyDiv`}>
            { this.props.isInstrument === true ?
              <div className={`${styles.widget}`}>
              {this.state.isAddWidgetDisabled === true ?
              <div className={`${styles.instrumentList} ${styles.disabled}`} id="addWidgetInst"></div>:
              <div className={`${styles.instrumentList}`} onClick={() => this.addNewWidget('instrument')} id="addWidgetInst"></div>
              }
              <p>{i18next.t("instrumentList")}</p>
            </div> : null }

            { this.props.isMargin === true && this.props.userDetail.SUB_TRD!=true ?
              <div className={`${styles.widget}`}>
                {this.state.isAddWidgetDisabled === true ?
                  <div className={(this.props.userDetail.newRiskCheckType==="MT_AsPerAcc" && this.props.DFA.MT==="MT_NoMrg") || this.props.userDetail.newRiskCheckType==="MT_NoMrg" ? `${styles.NoMarginOrd} ${styles.disabled}` : `${styles.margin} ${styles.disabled}`} id="addWidgetMrgin"></div>:
                  <div className={(this.props.userDetail.newRiskCheckType==="MT_AsPerAcc" && this.props.DFA.MT==="MT_NoMrg")|| this.props.userDetail.newRiskCheckType==="MT_NoMrg"? `${styles.NoMarginOrd}` : `${styles.margin}`} onClick={() => this.addNewWidget('margin')} id="addWidgetMrgin"></div>
                }
                {(this.props.userDetail.newRiskCheckType==="MT_AsPerAcc" && this.props.DFA.MT==="MT_NoMrg") || this.props.userDetail.newRiskCheckType==="MT_NoMrg" ?
                  <p>{i18next.t("positionWidget")}</p>:<p>{i18next.t("marginWidget")}</p>
                }
            </div> : null}

            {tco.length === 1 ? this.props.tradeWidgetCnt < 5 ?
              <div className={`${styles.widget}`}>
                { this.state.isAddWidgetDisabled === true ?
                  <React.Fragment>
                    { this.props.userDetail.enableCustomerOrder? this.props.userDetail.enableFXOrd===true ?
                      <div className={this.props.userDetail.showPriceSpread===true? `${styles.tradePanelFixSprd} ${styles.disabled}` : `${styles.tradePanelFix} ${styles.disabled}`} id="addWidgetTrade"></div>
                      :<div className={this.props.userDetail.showPriceSpread===true? `${styles.tradePanel} ${styles.disabled}` : `${styles.tradePanelWithnoSpread} ${styles.disabled}`} id="addWidgetTrade"></div>
                      :<div className={this.props.userDetail.showPriceSpread===true ? `${styles.tradePanelNoMrgWithSpd} ${styles.disabled}`: `${styles.tradePanelNoMrg} ${styles.disabled}`} id="addWidgetTrade"></div>
                    }
                  </React.Fragment>:
                  <React.Fragment>
                    { this.props.userDetail.enableCustomerOrder? this.props.userDetail.enableFXOrd===true ?
                      <div className={this.props.userDetail.showPriceSpread===true? `${styles.tradePanelFixSprd}`: `${styles.tradePanelFix}`} onClick={() => this.addNewWidget('trade')} id="addWidgetTrade"></div>
                      :<div className={this.props.userDetail.showPriceSpread===true? `${styles.tradePanel}`: `${styles.tradePanelWithnoSpread}`} onClick={() => this.addNewWidget('trade')} id="addWidgetTrade"></div>
                      :<div className={this.props.userDetail.showPriceSpread===true ? `${styles.tradePanelNoMrgWithSpd}`: `${styles.tradePanelNoMrg}`} onClick={() => this.addNewWidget('trade')} id="addWidgetTrade"></div>
                    }
                  </React.Fragment>
                }
                <p>{i18next.t("trdWidget")}</p>
              </div>
             : null
             : tco.length > 0 && this.props.tradeWidgetCnt < appConstants.TRADE_PANEL_COUNT ?
             <div className={`${styles.widget}`}>
               { this.state.isAddWidgetDisabled === true ?
                <React.Fragment>
                  {this.props.userDetail.enableCustomerOrder? this.props.userDetail.enableFXOrd===true ?
                    <div className={this.props.userDetail.showPriceSpread===true ? `${styles.tradePanelFixSprd} ${styles.disabled}`: `${styles.tradePanelFix} ${styles.disabled}`} id="addWidgetTrade"></div>
                    :<div className={this.props.userDetail.showPriceSpread===true ? `${styles.tradePanel} ${styles.disabled}`: `${styles.tradePanelWithnoSpread} ${styles.disabled}`} id="addWidgetTrade"></div>
                    :<div className={this.props.userDetail.showPriceSpread===true ? `${styles.tradePanelNoMrgWithSpd} ${styles.disabled}`: `${styles.tradePanelNoMrg} ${styles.disabled}`} id="addWidgetTrade"></div>
                    }
                  }
                </React.Fragment>:
                <React.Fragment>
                  { this.props.userDetail.enableCustomerOrder?this.props.userDetail.enableFXOrd===true ?
                    <div className={this.props.userDetail.showPriceSpread===true ? `${styles.tradePanelFixSprd}`: `${styles.tradePanelFix}`} onClick={() => this.addNewWidget('trade')} id="addWidgetTrade"></div>
                    :<div className={this.props.userDetail.showPriceSpread===true ? `${styles.tradePanel}`: `${styles.tradePanelWithnoSpread}`} onClick={() => this.addNewWidget('trade')} id="addWidgetTrade"></div>
                    :<div className={this.props.userDetail.showPriceSpread===true ? `${styles.tradePanelNoMrgWithSpd}`: `${styles.tradePanelNoMrg}`} onClick={() => this.addNewWidget('trade')} id="addWidgetTrade"></div>
                  }
                </React.Fragment>
               }
               <p>{i18next.t("trdWidget")}</p>
             </div>
            : null
            }

            <div className={`${styles.widget}`}>
              {this.state.isAddWidgetDisabled === true ?
                <div className={`${styles.chart} ${styles.disabled}`}></div>:
                <div className={`${styles.chart}`} onClick={() => this.addNewWidget('chart')} id="addWidgetGraph"></div>
              }
              <p>{i18next.t("graph")}</p>
            </div>

	          <div className={`${styles.widget}`}>
              {this.state.isAddWidgetDisabled === true ?
  	            <div className={this.props.userDetail.enableCustomerOrder ? this.props.userDetail.enableFXOrd===true ? `${styles.outstandingOrderFix} ${styles.disabled}` : `${styles.outstandingOrder} ${styles.disabled}`:`${styles.oustandingOrderNoMrg} ${styles.disabled}`} id="addWidgetTrdBook"></div>:
                <div className={this.props.userDetail.enableCustomerOrder ? this.props.userDetail.enableFXOrd===true ? `${styles.outstandingOrderFix}`:`${styles.outstandingOrder}`:`${styles.oustandingOrderNoMrg}`} onClick={() => this.addNewWidget('TradeActivityBook')} id="addWidgetTrdBook"></div>
              }
              <p>{i18next.t("trdActivityBook")}</p>
           </div>

          </div>
          </div>
        </Modal>
      </div>
    );
  }
}
